/** Cashier (POS) copy: bills, cash payments, receipts and the cash shift. */
export const enKasir = {
  'kasir.nav.tables': 'Tables',
  'kasir.nav.shift': 'Cash shift',
  'kasir.floor.subtitle': 'Pick a table to seat guests, take orders or settle the bill.',

  // ---- Bill -----------------------------------------------------------------------
  'kasir.bill.tab': 'Bill',
  'kasir.bill.lines': 'Bill lines',
  'kasir.bill.item': 'Item',
  'kasir.bill.amount': 'Amount',
  'kasir.bill.subtotal': 'Subtotal',
  'kasir.bill.service': 'Service charge ({percent}%)',
  'kasir.bill.tax': 'Tax ({percent}%)',
  'kasir.bill.rounding': 'Rounding',
  'kasir.bill.total': 'Total',
  'kasir.bill.paid': 'Paid',
  'kasir.bill.outstanding': 'Outstanding',
  'kasir.bill.number': 'Bill {number}',
  'kasir.bill.ready': 'Bill {number} is ready.',
  'kasir.bill.nothing':
    'Nothing to bill yet — items appear here once they are sent to the kitchen.',
  'kasir.bill.createHint':
    '{count} sent items will be billed. Totals are calculated by the server.',
  'kasir.bill.create': 'Create bill',
  'kasir.bill.creating': 'Creating bill…',
  'kasir.bill.draftsWarning': '{count} items are not sent yet and are not on the bill.',
  'kasir.bill.refreshHint': '{count} items were sent after this bill was created.',
  'kasir.bill.refresh': 'Update bill',
  'kasir.bill.refreshing': 'Updating…',
  'kasir.bill.void': 'Void bill',
  'kasir.bill.voidTitle': 'Void bill {number}?',
  'kasir.bill.voidBody':
    'Only for a bill nobody has paid. The items stay on the order: cancel them or bill them again.',
  'kasir.bill.voiding': 'Voiding…',
  'kasir.bill.voided': 'Bill {number} voided',
  'kasir.bill.payments': 'Payments',
  'kasir.bill.paymentLine': 'Cash · {time}',

  // ---- Payment --------------------------------------------------------------------
  'kasir.pay.needShift': 'Open a cash shift before taking payments.',
  'kasir.pay.tendered': 'Cash received',
  'kasir.pay.quick': 'Quick amounts',
  'kasir.pay.exact': 'Exact amount',
  'kasir.pay.changeEstimate': 'Estimated change:',
  'kasir.pay.partialEstimate': 'Partial payment — remaining:',
  'kasir.pay.exactEstimate': 'Exact amount — no change.',
  'kasir.pay.enterAmount': 'Enter the cash received.',
  'kasir.pay.action': 'Take cash {amount}',
  'kasir.pay.pending': 'Recording payment…',
  'kasir.pay.partialDone': 'Received {paid}. Remaining {remaining}.',
  'kasir.keypad.label': 'Numeric keypad',
  'kasir.keypad.backspace': 'Delete last digit',

  // ---- Receipt --------------------------------------------------------------------
  'kasir.receipt.title': 'Receipt',
  'kasir.receipt.browserPrint':
    'Paid in full. Printing uses the browser print dialog — not a thermal receipt printer.',
  'kasir.receipt.print': 'Print (browser)',
  'kasir.receipt.done': 'Done',
  'kasir.receipt.change': 'Change to give',
  'kasir.receipt.tenderedLine': 'Cash received',
  'kasir.receipt.billNo': 'Bill {number}',
  'kasir.shift.cashRefunds': 'Cash refunds',
  'kasir.shift.stale':
    'This shift has been open since {date}. Count the drawer and close it, then open a new shift for today.',
  'kasir.shift.cashRefundsDescription': 'Cash given back from this drawer.',
  'kasir.refund.online': 'Online',
  'kasir.refund.onlineAction': 'Return online payment {amount}',
  'kasir.refund.onlineTitle': 'Return online payment on bill {number}',
  'kasir.refund.onlineBody':
    'The guest paid {amount} online, but the bill could not take it. The payment provider gives it all back.',
  'kasir.refund.onlineDone': 'Online payment on bill {number} returned',
  'kasir.refund.mode': 'Refund by',
  'kasir.refund.pendingNote': 'waiting for the provider',
  'kasir.refund.byItems': 'Items',
  'kasir.refund.byAmount': 'Amount',
  'kasir.refund.unitsLeft': '{count} left to refund',
  'kasir.refund.less': 'One less {name}',
  'kasir.refund.more': 'One more {name}',
  'kasir.refund.total': 'Refund:',
  'kasir.refund.onlineNote':
    'The payment provider gives the money back; it may take a while to confirm.',
  'kasir.refund.slipTitle': 'Refund slip',
  'kasir.refund.slipTotal': 'Refunded',
  'kasir.refund.slipReason': 'Reason: {reason}',
  'kasir.refund.slipPending': 'Waiting for the payment provider to confirm.',
  'kasir.refund.title': 'Refunds',
  'kasir.refund.description':
    "Today's settled bills. A refund gives money back; the bill stays settled.",
  'kasir.refund.empty': 'No settled bills today.',
  'kasir.refund.action': 'Refund',
  'kasir.refund.refunded': '{amount} refunded',
  'kasir.refund.dialogTitle': 'Refund bill {number}',
  'kasir.refund.payment': 'Payment',
  'kasir.refund.amount': 'Amount to give back',
  'kasir.refund.max': 'At most {amount}',
  'kasir.refund.cashNote':
    'Cash comes out of your drawer and lowers the expected cash of your shift.',
  'kasir.refund.confirm': 'Give refund',
  'kasir.refund.pending': 'Refunding…',
  'kasir.refund.done': '{amount} refunded',
  'kasir.receipt.pickupNo': 'Pickup no. {number}',
  'kasir.receipt.cashTendered': 'Cash',
  'kasir.receipt.changeLine': 'Change',
  'kasir.receipt.thanks': 'Thank you!',
  'kasir.receipt.notSettled': 'Not settled yet.',

  // ---- Shift ----------------------------------------------------------------------
  'kasir.shift.title': 'Cash shift',
  'kasir.shift.subtitle': 'Cash payments are recorded in your open shift.',
  'kasir.shift.statusOpen': 'Shift open',
  'kasir.shift.statusNone': 'No open shift',
  'kasir.shift.noneBanner': 'No cash shift is open. Open one before taking cash payments.',
  'kasir.shift.openAction': 'Open cash shift',
  'kasir.shift.openTitle': 'Open a cash shift',
  'kasir.shift.openDescription': 'Count the cash in the drawer and enter it as the opening float.',
  'kasir.shift.float': 'Opening float',
  'kasir.shift.floatDescription': 'Cash in the drawer at opening',
  'kasir.shift.open': 'Open shift',
  'kasir.shift.opening': 'Opening…',
  'kasir.shift.opened': 'Cash shift opened.',
  'kasir.shift.openedBy': 'Opened by {name} · {time}',
  'kasir.shift.expected': 'Expected cash',
  'kasir.shift.expectedDescription': 'Opening float + cash sales + pay-ins − pay-outs',
  'kasir.shift.cashSales': 'Cash sales',
  'kasir.shift.cashSalesDescription':
    '{count} cash payments in this shift (delivery platform payments are not cash)',
  'kasir.shift.payIn': 'Pay-ins',
  'kasir.shift.payInDescription': 'Cash added to the drawer',
  'kasir.shift.payOut': 'Pay-outs',
  'kasir.shift.payOutDescription': 'Cash taken out of the drawer',
  'kasir.move.title': 'Pay in / pay out',
  'kasir.move.description': 'Record cash added to or taken from the drawer, with a reason.',
  'kasir.move.type': 'Movement type',
  'kasir.move.payIn': 'Pay in',
  'kasir.move.payOut': 'Pay out',
  'kasir.move.amount': 'Amount',
  'kasir.move.reason': 'Reason',
  'kasir.move.reasonPlaceholder': 'e.g. change from the bank, ice purchase',
  'kasir.move.submit': 'Record movement',
  'kasir.move.doneIn': 'Pay-in of {amount} recorded.',
  'kasir.move.doneOut': 'Pay-out of {amount} recorded.',
  'kasir.close.title': 'Close shift',
  'kasir.close.description': 'Count the cash in the drawer. The difference is recorded.',
  'kasir.close.counted': 'Counted cash',
  'kasir.close.diffEstimate': 'Difference (estimate):',
  'kasir.close.notes': 'Notes',
  'kasir.close.submit': 'Close shift',
  'kasir.close.closing': 'Closing…',
  'kasir.close.confirmTitle': 'Close this cash shift?',
  'kasir.close.confirmBody':
    'Counted {counted} against an expected {expected}. Closing cannot be undone.',
  'kasir.close.done': 'Cash shift closed.',
  'kasir.close.balanced': 'balanced',
  'kasir.close.short': 'short',
  'kasir.close.over': 'over',
  'kasir.close.resultTitle': 'Shift closed',
  'kasir.close.resultDescription': 'Figures confirmed by the server.',
  'kasir.close.discrepancy': 'Difference',

  // ---- Takeaway & delivery orders (/kasir/pesanan) -----------------------------
  'kasir.shiftReport.title': 'SHIFT REPORT',
  'kasir.shiftReport.cashier': 'Cashier: {name}',
  'kasir.shiftReport.opened': 'Opened: {time}',
  'kasir.shiftReport.closed': 'Closed: {time}',
  'kasir.shiftReport.cash': 'Cash drawer',
  'kasir.shiftReport.items': 'Menu sold',
  'kasir.shiftReport.tables': 'Per table',
  'kasir.shiftReport.table': 'Table {name}',
  'kasir.shiftReport.transactions': 'Transactions',
  'kasir.shiftReport.printed': 'Printed {time}',
  'kasir.shiftReport.print': 'Print report',
  'kasir.shiftReport.printing': 'Printing…',
  'kasir.nav.report': 'Report',
  'kasir.report.title': 'Shift report',
  'kasir.report.subtitle': 'Your current cash shift: totals, cash in and out, refunds and closing.',
  'kasir.report.tab.summary': 'Summary',
  'kasir.report.tab.cash': 'Cash in/out',
  'kasir.report.tab.refunds': 'Refunds',
  'kasir.report.tab.close': 'Close shift',
  'kasir.report.byMethod': 'Totals by payment method',
  'kasir.nav.transactions': 'Transactions',
  'kasir.tx.title': 'Transactions',
  'kasir.tx.subtitle': 'Payments and refunds in your current shift.',
  'kasir.tx.tabShift': 'This shift ({count})',
  'kasir.tx.tabOpen': 'Open orders ({count})',
  'kasir.tx.noShift': 'Open a cash shift to start recording transactions.',
  'kasir.tx.empty': 'No transactions in this shift yet.',
  'kasir.tx.net': 'Total this shift',
  'kasir.tx.netHint': 'Payments received minus refunds, all methods',
  'kasir.tx.count': '{count} payments',
  'kasir.tx.refund': 'Refund',
  'kasir.tx.platform': 'Platform',
  'kasir.nav.orders': 'Orders',
  'kasir.nav.menu': 'Menu',
  'kasir.orders.title': 'Takeaway & delivery',
  'kasir.orders.subtitle':
    'Orders without a table: takeaway at the counter and delivery platforms.',
  'kasir.orders.new': 'New order',
  'kasir.orders.openTitle': 'Open orders',
  'kasir.orders.openDescription':
    'Kitchen status per order; open one to add items, bill and take payment.',
  'kasir.orders.empty': 'No open takeaway or delivery orders — create one with "New order".',
  'kasir.orders.closedTitle': 'Closed today ({count})',
  'kasir.orders.closedHint': 'Settled takeaway and delivery orders from today.',
  'kasir.orders.closedEmpty': 'No takeaway or delivery orders closed today yet.',
  'kasir.orders.col.number': 'Order',
  'kasir.orders.col.type': 'Type',
  'kasir.orders.col.ref': 'Platform no.',
  'kasir.orders.col.customer': 'Customer',
  'kasir.orders.col.items': 'Items',
  'kasir.orders.col.kitchen': 'Kitchen',
  'kasir.orders.col.total': 'Ordered',
  'kasir.orders.back': 'Back to orders',
  'kasir.orders.number': 'Order {number}',
  'kasir.orders.closedNote': 'This order is settled and closed.',
  'kasir.orders.cancelledNote': 'This order was cancelled.',
  'kasir.pickup.title': 'Ready for pickup',
  'kasir.pickup.description':
    'The kitchen marked these ready. Hand them to the customer or courier.',
  'kasir.pickup.action': 'Hand over',
  'kasir.pickup.done': 'Handed over: {label}.',
  'kasir.newOrder.title': 'New order',
  'kasir.newOrder.description': 'Takeaway at the counter, or an order from a delivery platform.',
  'kasir.newOrder.type': 'Order type',
  'kasir.newOrder.platform': 'Delivery platform',
  'kasir.newOrder.ref': 'Platform order number',
  'kasir.newOrder.refHint': 'As shown in the platform app, e.g. GF-123456.',
  'kasir.newOrder.customer': 'Customer name',
  'kasir.newOrder.submit': 'Create order',
  'kasir.newOrder.created': 'Order {number} created.',
  'kasir.newOrder.error.channel': 'Choose the delivery platform.',
  'kasir.newOrder.error.refRequired': 'Enter the platform order number.',
  'kasir.newOrder.error.refTooLong': 'Use at most 40 characters.',
  'kasir.newOrder.error.refDuplicate': 'This platform order has already been entered.',
  'kasir.newOrder.error.nameTooLong': 'Use at most 80 characters.',

  // ---- Platform payment (delivery) ---------------------------------------------
  'kasir.bill.platformLine': 'Platform · {time}',
  'kasir.platform.hint': 'Paid to {platform} by the customer. No cash and no cash shift needed.',
  'kasir.platform.action': 'Mark paid via {platform}',
  'kasir.platform.confirmTitle': 'Mark this bill paid via {platform}?',
  'kasir.platform.confirmBody':
    '{amount} is recorded as paid by {platform} for platform order {ref}. It is not counted as cash.',
  'kasir.receipt.platformPaid': 'Paid via {platform}',
  'kasir.receipt.platformLine': 'Paid via {platform}',

  // ---- Menu & availability (/kasir/menu) ---------------------------------------
  'kasir.menu.title': 'Menu',
  'kasir.menu.subtitle':
    'Mark items sold out when the kitchen runs out, and available again later.',
  'kasir.menu.subtitleReadOnly': 'The menu of this branch with prices and availability.',
  'kasir.menu.availableOnly': 'Available only',
  'kasir.menu.options': 'Options: {groups}',
  'kasir.menu.available': 'Available',
  'kasir.menu.markSoldOut': 'Mark sold out',
  'kasir.menu.markAvailable': 'Mark available',
  'kasir.menu.markedSoldOut': '{name} is marked sold out.',
  'kasir.menu.markedAvailable': '{name} is available again.',
  // ---- Guest online payments ---------------------------------------------------------------
  'kasir.bill.onlineLine': 'Online · {time}',
  'kasir.bill.onlinePending':
    'The guest is paying {amount} in the app right now. Do not collect it again.',
  'kasir.bill.onlineRefund':
    'Online payment of {amount} must be refunded to the guest: the bill could not take it.',
  'kasir.receipt.onlinePaid': 'Paid online',
  'kasir.receipt.onlineLine': 'Paid online',
  'kasir.orders.searchPlaceholder': 'Order no., platform no. or customer',
  'kasir.orders.allTypes': 'All types & platforms',
  'kasir.orders.filter.kitchen': 'Kitchen status',
  'kasir.orders.allKitchen': 'All kitchen statuses',
  // ---- QRIS / card on the restaurant's own terminal (ADR-0050) -------------------
  'kasir.pay.method': 'Payment method',
  'kasir.pay.cash': 'Cash',
  'kasir.pay.qris': 'QRIS',
  'kasir.pay.card': 'Card',
  'kasir.terminal.hintQris':
    "The customer scans the restaurant's QRIS. Check that the payment arrived in your merchant app, then record it.",
  'kasir.terminal.hintCard':
    'Charge the card on your EDC terminal, then record it with the approval code from the slip.',
  'kasir.terminal.amount': 'Amount',
  'kasir.terminal.amountHint': 'Enter less than the outstanding balance to split the bill.',
  'kasir.terminal.reference': 'Approval / reference code',
  'kasir.terminal.referenceHint': 'As printed on the EDC or QRIS slip (optional).',
  'kasir.terminal.actionQris': 'Record QRIS {amount}',
  'kasir.terminal.actionCard': 'Record card {amount}',
  'kasir.terminal.tooMuch':
    'More than the outstanding balance — there is no change for QRIS or card.',
  'kasir.bill.qrisLine': 'QRIS · {time}',
  'kasir.bill.cardLine': 'Card · {time}',
  'kasir.receipt.qrisLine': 'QRIS',
  'kasir.receipt.cardLine': 'Card',
  'kasir.receipt.refLine': 'Ref. {reference}',
  'kasir.receipt.qrisPaid': 'Paid by QRIS',
  'kasir.receipt.cardPaid': 'Paid by card',
  // ---- Direct bank transfer to the restaurant's account --------------------------
  'kasir.pay.transfer': 'Transfer',
  'kasir.terminal.referenceHintTransfer':
    'The transfer reference from your banking app (optional).',
  'kasir.terminal.hintTransfer':
    "The customer transfers to the restaurant's bank account. Check that it arrived in your banking app, then record it with the transfer reference.",
  'kasir.terminal.actionTransfer': 'Record transfer {amount}',
  'kasir.bill.transferLine': 'Transfer · {time}',
  'kasir.receipt.transferLine': 'Bank transfer',
  'kasir.receipt.transferPaid': 'Paid by bank transfer',
} as const;
